import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './card-header.scss';
import { GeckoIcon } from '../../';
import { GeckoBtn } from '../../';
import { GeckoBtns } from '../../';
import { GeckoBtnsModel } from '../../../models/';
import { GeckoFields } from '../../';
import { GECKO_CONSTS } from '../../../';
import { TooltipIdStr, Tooltip, OverlayTrigger } from '../../../';

class GeckoCardHeader extends Component {
  state = {
    search: '',
  };

  renderTitle() {
    let title = <span>{this.props.name}</span>;
    if (this.props.link) {
      title = (
        <span>
          <a href={this.props.link}>{this.props.name}</a>
        </span>
      );
    }
    return (
      <h2 className="header-title">
        {title}
        {this.renderIcon()}
      </h2>
    );
  }

  renderIcon() {
    const tipId = this.props.id || `${this.props.name}_col`;

    if (this.props.icon) {
      return (
        <React.Fragment>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={TooltipIdStr(tipId)}>{this.props.iconText}</Tooltip>
            }
          >
            <span
              style={this.props.onIconClick ? { cursor: 'pointer' } : null}
              id={TooltipIdStr(tipId)}
              className="header-icon"
              onClick={this.props.onIconClick || null}
            >
              <GeckoIcon icon={this.props.icon} />
            </span>
          </OverlayTrigger>
        </React.Fragment>
      );
    }
    return null;
  }

  renderSearch() {
    if (this.props.onSearch) {
      const fields = [
        {
          key: 'search',
          type: GECKO_CONSTS.FIELD_TYPE_SEARCH,
          width: '25%',
          placeholder: this.props.searchPlaceholder,
        },
      ];
      const onChange = (_key, value) => this.setState({ search: value });
      const onSubmit = () => this.props.onSearch(this.state.search);
      return (
        <GeckoFields
          values={this.state}
          fields={fields}
          handler={onChange}
          submitHandler={onSubmit}
        />
      );
    }
    return null;
  }

  renderBtns() {
    if (this.props.btns && this.props.btns.length) {
      return <GeckoBtns items={this.props.btns} />;
    }
    return null;
  }

  renderBackButton() {
    if (!this.props.onBack) {
      return null;
    }
    return (
      <div className="gecko-card-header__back-button">
        <GeckoBtn
          icon="far fa-long-arrow-left"
          type={GECKO_CONSTS.BTN_TYPE_NAKED}
          handler={this.props.onBack}
        />
      </div>
    );
  }

  renderFilterBar() {
    if (!this.props.filter) {
      return null;
    }
    return this.props.filter;
  }

  render() {
    return (
      <div className="gecko-card-header">
        {this.renderBackButton()}

        {this.renderTitle()}
        {this.renderFilterBar()}

        <div className="header-container clearfix">
          {this.props.children}
          {this.renderSearch()}
          {this.renderBtns()}
        </div>
      </div>
    );
  }
}

GeckoCardHeader.defaultProps = {
  btns: [],
};

GeckoCardHeader.propTypes = {
  btns: GeckoBtnsModel,
  name: PropTypes.string,
  icon: PropTypes.string,
  iconText: PropTypes.string,
  onIconClick: PropTypes.func,
  onSearch: PropTypes.func,
};

export default GeckoCardHeader;
